import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  back?: boolean;
  right?: ReactNode;
}

export default function PageHeader({ title, back, right }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="page-header">
      {back ? (
        <button className="header-back" onClick={() => navigate(-1)} aria-label="Go back">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={20} height={20}>
            <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      ) : (
        <div className="header-spacer" />
      )}
      <h1 className="header-title">{title}</h1>
      <div className="header-right">{right ?? <div className="header-spacer" />}</div>
    </header>
  );
}
